import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { OrderCollectionSheet } from '@/features/orders/components/order-collection-sheet'

// No preview gate here: whoever is allowed to open the order — the gatherer
// included — is allowed to print the sheet that travels with its tray. The
// API applies the same rule (order.view plus the assignee narrowing).
function PrintPage() {
  const { orderId } = Route.useParams()

  return (
    <Main>
      <OrderCollectionSheet orderId={orderId} />
    </Main>
  )
}

export const Route = createFileRoute('/_authenticated/orders/print/$orderId')({
  component: PrintPage,
})
